import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const WebsiteContext = createContext();

export const AppProvider = ({ children }) => {
  //rgb(250, 249, 246, 0.8)
  const [dark, setDark] = useState(true);
  const color = dark ? "#0d0d0d" : "#0d0d0d";
  const transition = dark ? "all 0.3s ease" : "all 0.3s ease";
  const handleThemeMode = () => {
    setDark(!dark);
  }; 
    const [loading, setLoading] = useState(true);

  
  const navigate = useNavigate();
  const handleRoute = (type) => {
    switch (type) {
      case "Home":
        navigate("/");
        break;
      case "Contact":
        navigate("/contact");
        break;
      case "About":
        navigate("/about_us");
        break;
      case "Blog":
        navigate("/blogs");
        break;
      case "blog":
        navigate("/blog");
        break;
      case "Privacy_policy":
        navigate("/privacy-policy");
        break;
      case "Terms_of_service":
        navigate("/terms-of-service");
        break;
      case "GettheApp":
        window.open(
          "https://play.google.com/store/apps/details?id=com.fluentfable&hl=en"
        );
        break;
      default:
        break;
    }
    setLoading(true);
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
     setLoading(false)
    }, 1000);
  };

  const [isMobileView, setIsMobileView] = useState(true);

  useEffect(() => {
    checkViewport();
    window.addEventListener("resize", checkViewport);
    return () => {
      window.removeEventListener("resize", checkViewport);
    };
  }, []);

  setTimeout(() => {
    setLoading(false);
  }, 200);

  const checkViewport = () => {
    const isMobileView = window.matchMedia("(max-width: 767px)").matches;
    setIsMobileView(isMobileView);
  };

  const contextValue = {
    handleThemeMode,
    dark,
    color,
    handleRoute,
    isMobileView,
    loading,
    transition
  };

  return (
    <WebsiteContext.Provider value={contextValue}>
      {children}
    </WebsiteContext.Provider>
  );
};
